import { gql, TypedDocumentNode } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import type {
  MemberElectionRunsQueryResponse,
  MemberElectionRunsQueryVariables,
  MemberElectionsQueryResponse,
  MemberElectionsQueryVariables
} from "./types";

export const MEMBER_ELECTIONS_QUERY: TypedDocumentNode<MemberElectionsQueryResponse, MemberElectionsQueryVariables> =
  gql`
    query MemberElections($first: Int, $last: Int, $before: String, $after: String, $search: String) {
      membershipApplications(
        first: $first
        last: $last
        before: $before
        after: $after
        applicationType: member
        status: approved
        pendingElection: true
        search: $search
      ) {
        nodes {
          id
          profilePhotoUrl
          email
          approvedAt
          electionDate {
            id
            electionDate
          }
          electionMemberClassification
          person {
            pgaId
            displayName
            primarySection {
              id
              name
            }
            primaryFacility {
              id
              name
            }
          }
        }
        ...PageInfo
      }
    }
    ${PAGE_INFO_FRAGMENT}
  `;

export const MEMBER_ELECTION_RUNS_QUERY: TypedDocumentNode<
  MemberElectionRunsQueryResponse,
  MemberElectionRunsQueryVariables
> = gql`
  query MemberElectionRuns($first: Int, $last: Int, $before: String, $after: String) {
    membershipElectionRuns(first: $first, last: $last, before: $before, after: $after) {
      nodes {
        id
        status
        triggerType
        startedAt
        completedAt
        totalCount
        initiatedBy {
          id
          name
        }
      }
      ...PageInfo
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

export type ElectionPastPresidentAssigneeNode = {
  id: string;
  name: string;
};

export type ElectionPastPresidentAssigneesQueryResponse = {
  electionPastPresidentAssignees: ElectionPastPresidentAssigneeNode[];
};

export const ELECTION_PAST_PRESIDENT_ASSIGNEES_QUERY: TypedDocumentNode<ElectionPastPresidentAssigneesQueryResponse> = gql`
  query ElectionPastPresidentAssignees {
    electionPastPresidentAssignees {
      id
      name
    }
  }
`;
